export const eventKindFragment = gql`
    fragment eventKindFragment on EventKindType {
        id
        name
        createdAt
    }
`;
